import { alpha, Popover, useTheme } from "@mui/material";
import NodeStatePorvider from "../../../context/NodeStatePorvider";
import BertCardWrapper from "../../BertCardWrapper";
import { useReactFlowStateContextProvider } from "../../../hooks/useReactFlowStateContextProvider";
import {
    MultiResponseBlockData,
    SingleResponseNode,
} from "../../../../types/bert";
import {
    MultiResponseNodeType,
    SingleResponseBlockType,
} from "../../../context/NodeStateContext";
import Attribute from "./Attribute";
import Moment from "./Moment";
import Parameter from "./Parameter";
import ValidateInfo from "./ValidateInfo";
import PredefinedFunction from "./PredefinedFunction";

const ViewBlockPopOver = ({
    open,
    anchorEl,
    type,
    onClose,
    id,
    data,
}: {
    open: boolean;
    anchorEl: HTMLElement | null;
    type: SingleResponseBlockType;
    onClose: () => void;
    id: string;
    data:
        | SingleResponseNode<NonNullable<SingleResponseBlockType>>["metadata"]
        | MultiResponseBlockData<MultiResponseNodeType>;
}) => {
    const { isGroupBlockTree } = useReactFlowStateContextProvider();
    const theme = useTheme();
    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
            }}
            transformOrigin={{
                vertical: isGroupBlockTree ? "bottom" : "top",
                horizontal: "center",
            }}
            sx={{
                ".MuiPaper-root": {
                    borderRadius: "10px",
                },
            }}
        >
            <NodeStatePorvider
                onNodeSaveCallBack={() => {}}
                nodeIdToUpdate={id}
                nodeDataToUpdate={data}
            >
                <BertCardWrapper
                    className="w-[400px]"
                    sx={{
                        p: 0,
                        border: "2px solid",
                        borderColor: alpha(theme.palette.primary.main, 0.2),
                    }}
                    onClick={(e) => {
                        const target = e.target as HTMLElement;
                        if (
                            target &&
                            target.classList.contains("view_block_close_button")
                        ) {
                            onClose();
                        }
                    }}
                >
                    {type === "attribute" ? <Attribute /> : <></>}
                    {type === "moment" ? <Moment /> : <></>}
                    {type === "parameter" && <Parameter />}
                    {type === "function" && <PredefinedFunction />}
                    {type === "validateInfo" && <ValidateInfo />}
                </BertCardWrapper>
            </NodeStatePorvider>
        </Popover>
    );
};

export default ViewBlockPopOver;
